import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=00db5b20&"
import script from "./CopyButton.vue?vue&type=script&lang=ts&"
export * from "./CopyButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports